'use client'

import { Account, User } from '@prisma/client'
import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useState
} from 'react'

import { ChatBoxIdentities } from '@/src/chat-box/db/identity'
import { emote7tv, emoteBttv, emoteFfz } from '@/src/chat-box/types/chat'

type context = {
  BROADCASTER_CUSTOM_REWARDS: typeCustomReward[]
  BROADCASTER_TWITCH_ACCOUNT: typeTwitchUser
  USER: User | null
  updateUser: (updates: Partial<User>) => void
  ChatBoxIdentities: ChatBoxIdentities
  ACCOUNTS: Account[] | null
  update_ACCOUNTS: Dispatch<SetStateAction<Account[] | null>>
  isMenuOpen: boolean
  setIsMenuOpen: Dispatch<SetStateAction<boolean>>
  Emotes7tv: emote7tv[]
  EmotesBttv: emoteBttv[]
  EmotesFfz: emoteFfz[]
}

export const Context = createContext<context>({
  BROADCASTER_CUSTOM_REWARDS: [],
  BROADCASTER_TWITCH_ACCOUNT: {
    broadcaster_type: '',
    description: '',
    created_at: '',
    display_name: '',
    id: '',
    login: '',
    offline_image_url: '',
    profile_image_url: '',
    type: '',
    view_count: 0,
    color: ''
  },
  USER: null,
  updateUser: () => {},
  ChatBoxIdentities: {},
  ACCOUNTS: null,
  update_ACCOUNTS: () => {},
  isMenuOpen: false,
  setIsMenuOpen: () => {},
  Emotes7tv: [],
  EmotesBttv: [],
  EmotesFfz: []
})

type Props = {
  children: ReactNode
  BROADCASTER_CUSTOM_REWARDS: typeCustomReward[]
  BROADCASTER_TWITCH_ACCOUNT: typeTwitchUser
  USER: User | null
  ChatBoxIdentities: ChatBoxIdentities
  ACCOUNTS: Account[] | null
  Emotes7tv: emote7tv[]
  EmotesBttv: emoteBttv[]
  EmotesFfz: emoteFfz[]
}

export default function ContextProvider({
  children,
  BROADCASTER_CUSTOM_REWARDS,
  BROADCASTER_TWITCH_ACCOUNT,
  USER: User,
  ChatBoxIdentities,
  ACCOUNTS: Accounts,
  Emotes7tv,
  EmotesBttv,
  EmotesFfz
}: Props) {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const [USER, update_USER] = useState(User)

  const updateUser = (updates: Partial<User>) => {
    update_USER((prev) => {
      if (!prev) return null

      return {
        ...prev,
        ...updates
      }
    })
  }

  const [ACCOUNTS, update_ACCOUNTS] = useState(Accounts)

  return (
    <Context.Provider
      value={{
        BROADCASTER_CUSTOM_REWARDS,
        BROADCASTER_TWITCH_ACCOUNT,
        USER,
        updateUser,
        ChatBoxIdentities,
        ACCOUNTS,
        update_ACCOUNTS,
        isMenuOpen,
        setIsMenuOpen,
        Emotes7tv,
        EmotesBttv,
        EmotesFfz
      }}
    >
      {children}
    </Context.Provider>
  )
}
